import React, {Component, Fragment} from "react";
import {Route, Switch} from "react-router-dom";
import Home from "../views/Authenticated/Home/Home";
import Beneficiaries from "../views/Authenticated/Beneficiaries/Beneficiaries";
import Transactions from "../views/Authenticated/Transactions/Transactions";
import Logout from "../views/Authenticated/Logout/Logout";
import TransactionCreation from "../views/Authenticated/Transactions/TransactionCreation";
import Quotation from "../views/Authenticated/Quotation/Quotation";
import BeneficiaryCreation from "../views/Authenticated/Beneficiaries/BeneficiaryCreation";
import ChangePassword from "../views/Authenticated/ChangePassword/ChangePassword";
import Tutorial from "../views/Authenticated/Tutorial/Tutorial";
import BeneficiaryTransactionCreation from "../views/Authenticated/Beneficiaries/BeneficiaryTransactionCreation";
import LimitIncrease from "../views/Authenticated/Limit/LimitIncrease";
import TransactionRedemptionComponent from "./Transaction/inbound/TransactionRedemptionComponent";
import PaymentRedirect from "../views/Authenticated/Payment/PaymentRedirect";
import PaymentResultPage from "../views/Authenticated/Payment/PaymentResultPage";

export default class AuthenticatedRouter extends Component {

    render() {
        return (
            <Fragment>
                <Switch>
                    <Route path={"/redeem-inbound-transaction"}>
                        <TransactionRedemptionComponent
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/payment/redirect/:success">
                        <PaymentRedirect
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/transactions">
                        <Transactions
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/redeem-transaction">
                        <TransactionRedemptionComponent
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/create-transaction">
                        <TransactionCreation
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/create-beneficiary-transaction/:beneficiaryId">
                        <BeneficiaryTransactionCreation
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/beneficiaries-existing" exact>
                        <Beneficiaries
                            {...this.props.childProps}
                            existingBeneficiary={true}
                        />
                    </Route>
                    <Route path="/beneficiaries" exact>
                        <Beneficiaries
                            {...this.props.childProps}
                            existingBeneficiary={false}
                        />
                    </Route>
                    <Route path="/create-beneficiary">
                        <BeneficiaryCreation
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/limit-increase">
                        <LimitIncrease
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/logout">
                        <Logout
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/quotation">
                        <Quotation
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/change-pin">
                        <ChangePassword
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/tutorial">
                        <Tutorial
                            {...this.props.childProps}
                        />
                    </Route>
                    <Route path="/payment/complete/:result" component={PaymentResultPage}/>
                    <Route path="">
                        <Home
                            {...this.props.childProps}
                        />
                    </Route>
                </Switch>

            </Fragment>
        );
    }
}
